export default __webpack_public_path__ + "static/media/trackdays-header.a98cdf2e.jpg";